import React from 'react';
import { Card, Form, Button } from 'react-bootstrap';
import QuestionField from './QuestionField';

const SurveyForm = ({ 
  survey, 
  answers, 
  onAnswerChange, 
  onSubmit, 
  submitting = false, 
  showSubmitButton = true,
  submitButtonText = "Save Answers",
  submitButtonVariant = "primary",
  submitButtonSize = "lg",
  recentlyFilledAnswers = [],
  emptyStateMessage = "No answers filled yet.",
  emptyStateIcon = null,
  cardClassName = "mb-4"
}) => {

  // Get all questions from groups (including nested) and general questions
  const getAllQuestionsFromGroup = (group) => {
    let questions = [...(group.questions || [])];
    if (group.sub_groups) {
      group.sub_groups.forEach(subGroup => {
        questions = questions.concat(getAllQuestionsFromGroup(subGroup));
      });
    }
    return questions;
  };

  const allQuestions = [
    ...(survey.general_questions || []),
    ...(survey.groups || []).flatMap(group => getAllQuestionsFromGroup(group))
  ];

  return (
    <Form onSubmit={onSubmit}>
      {/* Empty state */}
      {Object.keys(answers).length === 0 && emptyStateMessage && (
        <div className="text-center py-5 text-muted">
          {emptyStateIcon && (
            <div className="mb-3">
              {emptyStateIcon}
            </div>
          )}
          <p>{emptyStateMessage}</p>
        </div>
      )}

      {/* Render grouped questions */}
      {survey.groups && survey.groups.map(group => {
        const renderGroup = (grp, level = 0) => (
          <Card key={grp.id} className={`mb-${level === 0 ? 4 : 3}`} style={{ marginLeft: `${level * 20}px` }}>
            <Card.Header className={level > 0 ? 'bg-light' : ''}>
              <h3 className={`h${Math.min(5 + level, 6)} mb-0 text-primary ${level === 0 ? 'border-bottom pb-2' : ''}`}>
                {grp.name}
              </h3>
            </Card.Header>
            <Card.Body>
              {/* Render direct questions of this group */}
              {grp.questions && grp.questions.map(question => (
                <QuestionField 
                  key={question.id} 
                  question={question} 
                  value={answers[question.id] || ''} 
                  onChange={(value) => onAnswerChange(question.id, value)}
                  isHighlighted={recentlyFilledAnswers.includes(question.id)}
                />
              ))}
              
              {/* Recursively render sub-groups */}
              {grp.sub_groups && grp.sub_groups.map(subGroup => 
                renderGroup(subGroup, level + 1)
              )}
            </Card.Body>
          </Card>
        );
        
        return renderGroup(group);
      })}
      
      {/* Render general questions */}
      {survey.general_questions && survey.general_questions.length > 0 && (
        <Card className={cardClassName}>
          <Card.Header>
            <h3 className="h5 mb-0 text-primary border-bottom pb-2">General Questions</h3>
          </Card.Header>
          <Card.Body>
            {survey.general_questions.map(question => (
              <QuestionField 
                key={question.id} 
                question={question} 
                value={answers[question.id] || ''} 
                onChange={(value) => onAnswerChange(question.id, value)}
                isHighlighted={recentlyFilledAnswers.includes(question.id)}
              />
            ))}
          </Card.Body>
        </Card>
      )}
      
      {/* Submit button */}
      {showSubmitButton && Object.keys(answers).length > 0 && (
        <div className="d-grid mt-4">
          <Button 
            type="submit" 
            variant={submitButtonVariant} 
            disabled={submitting}
            size={submitButtonSize}
          >
            {submitting ? 'Saving...' : submitButtonText}
          </Button>
        </div>
      )}
    </Form>
  );
};

export default SurveyForm;
